import { render, staticRenderFns } from "./PageWechatLoginAuth.vue?vue&type=template&id=adefa6cc&scoped=true"
import script from "./PageWechatLoginAuth.vue?vue&type=script&lang=js"
export * from "./PageWechatLoginAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adefa6cc",
  null
  
)

export default component.exports